// src/context/ScrollContext.jsx
import { createContext } from "react";

export const ScrollContext = createContext();
